export default __webpack_public_path__ + "1732a5ce290310d6ea270e5f0db0f2a6.png";